

























































import Vue from 'vue';
import Component from 'vue-class-component';
import { InternalSite, InvalidParam } from '../../api';
import { labelAdminApis, LabelInfo } from '@/api/label.api';

@Component
export default class SiteEditDialog extends Vue {
  readonly labelWidth = '6rem';
  readonly formRules = {
    name: { required: true, message: '请输入站点标识' },
    title: { required: true, message: '请输入站点名称' }
  };

  dialogVisible = false;
  editAddressOnly = false;
  labelList: Array<LabelInfo> | null = null;

  site: InternalSite | null = null;
  errors: any = {};

  async saveSite() {
    try {
      if (this.editAddressOnly && this.site) {
        await this.$store.dispatch('sites/saveAddress', this.site);
      } else {
        await this.$store.dispatch('sites/save', this.site);
      }
      await this.$store.dispatch('sites/refresh');
      this.$notify.success({
        title: '提示',
        message: `保存站点[${this.site?.title}]成功`,
        duration: 2000
      });
      this.dialogVisible = false;
    } catch (e) {
      if (e instanceof InvalidParam) {
        this.errors = e.params;
      } else {
        this.$notify.error(e.message);
      }
    }
  }

  async show(site: InternalSite | null, editAddressOnly: boolean) {
    this.errors = {};
    this.editAddressOnly = editAddressOnly;
    this.labelList = await labelAdminApis.listLabels();
    if (site) {
      this.site = JSON.parse(JSON.stringify(site));
    } else {
      this.site = { accessible: true } as InternalSite;
    }
    this.dialogVisible = true;
  }
}
